import { defineNuxtPlugin, useRouter } from '#imports'
import { useTrackingStore } from '~/stores/tracking'

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter()
  
  nuxtApp.hook('app:mounted', () => {
    const trackingStore = useTrackingStore()
    
    // Initialize session and location if consent is granted
    trackingStore.initialize()
    
    // Log the initial page view
    trackingStore.logPageView(router.currentRoute.value.fullPath)
  })

  // Watch route changes
  router.afterEach((to) => {
    const trackingStore = useTrackingStore()
    trackingStore.logPageView(to.fullPath)
  })
})
